module.exports = "/_next/static/images/DefaultBeautyImageStore-626f06f12710b8c979a8aaffe1ab9bcb.webp";